import { BarcodeComponent } from "@/Components/Index";
import { formatMX } from "@/Utils/Fomat.price";
import { useRef } from "react";
import Skeleton from "react-loading-skeleton";

type Props = {
  names: string;
  quant: number;
  totalSalesPrice: number;
  orderNo: string;
  PrintTitle: string;
  FechaActual: string;
  orderCode: string;
};

export const PrintDataView = ({
  names,
  quant,
  totalSalesPrice,
  orderNo,
  PrintTitle,
  FechaActual,
  orderCode,
}: Props): JSX.Element => {
  //referencia
  const printRef = useRef<HTMLDivElement | null>(null);
  return (
    <div className="row" ref={printRef}>
      <div className="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
        <div className="ps-block--checkout-order">
          <div className="ps-block__content text_Center___develop">
            <span>
              <i className="develop___icons fa-sharp-duotone fa-solid fa-bag-shopping"></i>
            </span>
            <figure>
              <h2>¡Gracias por tu compra!</h2>
            </figure>
            <strong className="develop___text">Articulo:</strong>
            <h3>{names}</h3>
            <strong className="develop___text develop___salto_text">
              Cantidad:
            </strong>
            <h3>{quant ?? 0 > 0 ? quant : 1}</h3>
            <strong className="develop___text develop___salto_text">
              Total de la orden:
            </strong>
            <h3 className="develop___salto_text">
              $ {totalSalesPrice > 0 ? formatMX(totalSalesPrice) : <Skeleton />}
            </h3>
            <strong className="develop___text develop___salto_text">
              Número de pedido:
            </strong>
            <h3>{orderNo}</h3>
            <strong className="develop___text develop___salto_text">
              Metodo de entrega:
              <h3>{PrintTitle}</h3>
            </strong>
            {PrintTitle == "Recoger en tienda" ? (
              <>
                <strong className="develop___text develop___salto_text">
                  Entrega en:
                  <h3>Soriana Híper San Pedro</h3>
                </strong>
                <strong className="develop___text develop___salto_text">
                  A partir del día:
                  <h3>{FechaActual}</h3>
                </strong>
              </>
            ) : (
              ""
            )}
            <strong className="develop___text develop___salto_Codbarra">
              Presenta este código de barras impreso al pagar en tienda
            </strong>
            <div className="row">
              <div className="col-md-12 col-12">
                {
                  <BarcodeComponent
                    orderCode={orderCode}
                    width={2}
                    height={100}
                  />
                }
              </div>
            </div>
            <strong className="develop___text">
              El código tendrá validez solo por 24 hrs. a partir de esta
              confirmación
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
};
